// Keep legacy or incomplete company records safe for text rendering and sorting.
export function startupDisplayName(value) {
  if (typeof value === 'string') return value.trim() || 'Company';
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  return 'Company';
}

export function normalizeCompanyRecord(company) {
  if (!company || typeof company !== 'object' || Array.isArray(company)) return null;
  const startup_name = startupDisplayName(company.startup_name);
  const badges = Array.isArray(company.badges) ? company.badges : typeof company.badges === 'string' ? [company.badges] : [];
  return startup_name === company.startup_name && badges === company.badges ? company : { ...company, startup_name, badges };
}

export function normalizeCompanyRecords(records) {
  return Array.isArray(records) ? records.map(normalizeCompanyRecord).filter(Boolean) : [];
}
